import {gql} from '@apollo/client';

/**
 * 客诉工作台 DSP 筛选下拉。
 * 不用 central getAllDsps：后者会为每个 DSP 串查结算配置，且对 wms 返回全美 DSP。
 */
export const GET_COMPLAINT_DSP_OPTIONS = gql`
    query GetComplaintDspOptions($warehouseId: Long) {
        getComplaintDspOptions(warehouseId: $warehouseId) {
            id
            name
            dspCode
        }
    }
`;

export interface ComplaintDspOption {
    id: number;
    name: string;
    dspCode?: string | null;
}

export interface GetComplaintDspOptionsResponse {
    getComplaintDspOptions: ComplaintDspOption[];
}

export interface GetComplaintDspOptionsVariables {
    warehouseId?: number | null;
}
